const SvgGridSelected2 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 35 32">
    <path d="M.727.727h14.545V8H.727zm0 11.637h14.545v7.273H.727zM.727 24h14.545v7.273H.727zM19.636.727h14.545V8H19.636zm0 11.637h14.545v7.273H19.636zm0 11.636h14.545v7.273H19.636z" />
  </svg>;
export default SvgGridSelected2;